import { useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';

type WindowResizeT = ClientRect | DOMRect;

const screenSize = () => window.document.body.getBoundingClientRect();

const useWindowResize = (
  cb: (screenInfo?: WindowResizeT) => void,
  isInitScreenInfo = false,
  delay = 200
): void => {
  const debounceCb = useDebouncedCallback(() => cb(screenSize()), delay);

  useEffect(() => {
    if (!window) {
      return;
    }

    if (isInitScreenInfo) {
      setTimeout(() => cb(screenSize()));
    }

    window.addEventListener('resize', debounceCb);

    return () => window.removeEventListener('resize', debounceCb);
  }, []);
};

export default useWindowResize;
